import { render, staticRenderFns } from "./FinalDocumentForm.vue?vue&type=template&id=5e77d225&"
import script from "./FinalDocumentForm.vue?vue&type=script&lang=ts&"
export * from "./FinalDocumentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports